export const text = {
  modalTitle: '¿Quieres salir sin guardar los cambios?',
  modalBody: 'No podrás recuperar la información modificada.',
  modalAcceptBtn: 'Sí, salir',
  modalCancelBtn: 'No, regresar'
};
